import styled from '@emotion/styled';
import { Typography } from '@innovamat/glimmer-components';
import {
  CARD_STATUS,
  type OperationTable,
} from '../../../modules/fluency/deck-report';

const StyledHeaderCell = styled(Typography.Subtitle1)<{ isLocked?: boolean }>`
  text-align: center;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.sizes.normal};
  color: ${({ isLocked, theme }) =>
    isLocked
      ? `${theme.tokens.color.alias.cm.text['text-disabled'].value}`
      : ''};
`;

function HeaderCell({
  column,
  columnIndex,
}: {
  column?: OperationTable;
  columnIndex: number;
}): JSX.Element {
  const columnLocked = column?.cards?.length
    ? column.cards.every((c) => c.status === CARD_STATUS.LOCKED)
    : false;

  return (
    <StyledHeaderCell key={columnIndex} isLocked={columnLocked}>
      {column?.operand2 || columnIndex + 1}
    </StyledHeaderCell>
  );
}

export { HeaderCell, StyledHeaderCell };
